/**
 * Ryan O'Dowd
 * 2024-02-08
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({safeAreaInsets}) => {
  return {
    innerContainer: {
      flexGrow: 1,
      justifyContent: 'space-between',
      // @TODO: paddingHorizontal: 8,
    },
    verseMemoryStyles: { // @NOTE: this exists for group assignments...if the verse memory is in a list of assignments, the outer container has sufficient bottom padding, but if it's in an assignment, we need to add the padding manually
      paddingBottom: safeAreaInsets.bottom,
    },
    assignmentWrapper: {
      flex: 1,
    },
    finishButtonWrapper: {
      margin: 8,
      marginBottom: safeAreaInsets.bottom,
    },
  };
};

export default getStyles;
